module.exports = __webpack_public_path__ + "img/icon-select.f044cf17.svg";